<div class="overlay" *ngIf="loading$ | async">
  <div class="overlay__inner">
    <div class="overlay__content"><span class="spinner"></span></div>
  </div>
</div>
